import Domain from './domainBase';

export class ResetPasswordPolicyOptions extends Domain {
    autoEnrollEnabled: boolean = false;
}
